// removed by extract-text-webpack-plugin
module.exports = {"SupportContainer":"style__SupportContainer___1FyTG","SupportContainerButton":"style__SupportContainerButton___1EwFh","SupportTable":"style__SupportTable___3ovzL","SupportTableArrow":"style__SupportTableArrow___e9RFh","SupportTableTitle":"style__SupportTableTitle___ebUjZ","Border":"style__Border___3lgFs","SupportTableRow":"style__SupportTableRow___3d6lv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Support/style.scss
// module id = 1384
// module chunks = 0